import { render, staticRenderFns } from "./UpButton.vue?vue&type=template&id=71ed3692&scoped=true&"
import script from "./UpButton.vue?vue&type=script&lang=js&"
export * from "./UpButton.vue?vue&type=script&lang=js&"
import style0 from "./UpButton.vue?vue&type=style&index=0&id=71ed3692&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ed3692",
  null
  
)

export default component.exports